import React from "react";
import Progress from "../../../components/progress";
import {  MdCheckCircle, MdOutlineError, MdCancel } from "react-icons/md";

import {
  createColumnHelper,
  SortingState
} from "@tanstack/react-table";
import { formatTime, timeDiffer } from "../../../utils/helper";


const columnHelper = createColumnHelper();

export const FeatureFlowColumns = [
    columnHelper.accessor("featureName", {
      id: "featureName",
      header: () => (
        <p className="text-sm font-bold text-gray-600 dark:text-white">Feature Name</p>
      ),
      cell: (info) => (
        <p className="text-sm font-bold text-navy-700 dark:text-white">
          {info.getValue()}
        </p>
      ),
    }),
    columnHelper.accessor("totalUser", {
      id: "totalUser",
      header: () => (
        <p className="text-sm font-bold text-gray-600 dark:text-white">Total Users Visited</p>
      ),
      cell: (info) => (
        <p className="text-sm font-bold text-navy-700 dark:text-white">
          {info.getValue().length}
        </p>
      ),
    }),
    columnHelper.accessor("eventList", {
      id: "eventList",
      header: () => (
        <p className="text-sm font-bold text-gray-600 dark:text-white">Total pages involved</p>
      ),
      cell: (info) => (
        <p className="text-sm font-bold text-navy-700 dark:text-white">
          {info.getValue().length}
        </p>
      ),
    }),
    columnHelper.accessor("PaidUserClicks", {
      id: "PaidUserClicks",
      header: () => (
        <p className="text-sm font-bold text-gray-600 dark:text-white">Total Paid users</p>
      ),
      cell: (info) => (
        <p className="text-sm font-bold text-navy-700 dark:text-white">
          {info.getValue().length}
        </p>
      ),
    }),
    columnHelper.accessor("FreeTrailsUserClicks", {
      id: "FreeTrailsUserClicks",
      header: () => (
        <p className="text-sm font-bold text-gray-600 dark:text-white">Total Free-Trail users</p>
      ),
      cell: (info) => (
        <p className="text-sm font-bold text-navy-700 dark:text-white">
          {info.getValue().length}
        </p>
      ),
    }),
    columnHelper.accessor("TotalEvents", {
      id: "TotalEvents",
      header: () => (
        <p className="text-sm font-bold text-gray-600 dark:text-white">Total Events Click</p>
      ),
      cell: (info) => (
        <p className="text-sm font-bold text-navy-700 dark:text-white">
          {info.getValue().length}
        </p>
      ),
    }),
    columnHelper.accessor("created_at", {
      id: "created_at",
      header: () => (
        <p className="text-sm font-bold text-gray-600 dark:text-white">Created at </p>
      ),
      cell: (info) => (
        <p className="text-sm font-bold text-navy-700 dark:text-white">
          {timeDiffer(info.getValue()) +' ' + 'ago'}
        </p>
      ),
    }),
  ]; 

  // {"_id":"65c101a1f83a8ab363ebdc8c","userName":"Deva","userEmail":"deva@mavencart.com","companyIndividual":"Individual","averageTimeSpentOnWebsite":"1549","lastActivity":"Mon Feb 05 2024 21:11:21 GMT+0530 (India Standard Time)","totalFeaturesExplored":["65c0c6fe0c9a6b8e3a3bb8ac"],"totalPagesExplored":["65b8e5f4a2f3a8730950f38f"],"timeline":[],"__v":0,"paidFreeTrailUser":"paid"}
 export const FeaturePageColumns = [
  columnHelper.accessor("userName", {
    id: "userName",
    header: () => (
      <p className="text-sm font-bold text-gray-600 dark:text-white">User Name</p>
    ),
    cell: (info) => (
      <p className="text-sm font-bold text-navy-700 dark:text-white">
        {info.getValue()}
      </p>
    ),
  }),
  columnHelper.accessor("userEmail", {
    id: "userEmail",
    header: () => (
      <p className="text-sm font-bold text-gray-600 dark:text-white">User Email</p>
    ),
    cell: (info) => (
      <p className="text-sm font-bold text-navy-700 dark:text-white">
        {info.getValue()}
      </p>
    ),
  }),
  columnHelper.accessor("companyIndividual", {
    id: "companyIndividual",
    header: () => (
      <p className="text-sm font-bold text-gray-600 dark:text-white">User Occupation</p>
    ),
    cell: (info) => (
      <p className="text-sm font-bold text-navy-700 dark:text-white">
        {info.getValue()}
      </p>
    ),
  }),
  columnHelper.accessor("lastActivity", {
    id: "lastActivity",
    header: () => (
      <p className="text-sm font-bold text-gray-600 dark:text-white">lastActivity</p>
    ),
    cell: (info) => (
      <p className="text-sm font-bold text-navy-700 dark:text-white">
        {timeDiffer(info.getValue())}
      </p>
    ),
  }),
  columnHelper.accessor("totalFeaturesExplored", {
    id: "totalFeaturesExplored",
    header: () => (
      <p className="text-sm font-bold text-gray-600 dark:text-white">totalFeaturesExplored</p>
    ),
    cell: (info) => (
      <p className="text-sm font-bold text-navy-700 dark:text-white">
        {info.getValue()?.length}
      </p>
    ),
  }),
  columnHelper.accessor("paidFreeTrailUser", {
    id: "paidFreeTrailUser",
    header: () => (
      <p className="text-sm font-bold text-gray-600 dark:text-white">User Status</p>
    ),
    cell: (info) => (
      <p className="text-sm font-bold text-navy-700 dark:text-white">
        {info.getValue()+' '+ 'user'}
      </p>
    ),
  }),
  columnHelper.accessor("averageTimeSpentOnWebsite", {
    id: "averageTimeSpentOnWebsite",
    header: () => (
      <p className="text-sm font-bold text-gray-600 dark:text-white">Avg Time</p>
    ),
    cell: (info) => (
      <p className="text-sm font-bold text-navy-700 dark:text-white">
        { formatTime(info.getValue())}
      </p>
    ),
  }),
 ];

 export const FeaturePageEventsColumns = [
  columnHelper.accessor("tag", {
    id: "tag",
    header: () => (
      <p className="text-sm font-bold text-gray-600 dark:text-white">Tag</p>
    ),
    cell: (info) => (
      <p className="text-sm font-bold text-navy-700 dark:text-white">
        {info.getValue()}
      </p>
    ),
  }),
  // columnHelper.accessor("onclick", {
  //   id: "onclick",
  //   header: () => (
  //     <p className="text-sm font-bold text-gray-600 dark:text-white">Click Events</p>
  //   ),
  //   cell: (info) => (
  //     <p className="text-sm font-bold text-navy-700 dark:text-white">
  //       {info.getValue()}
  //     </p>
  //   ),
  // }),
  columnHelper.accessor("text", {
    id: "text",
    header: () => (
      <p className="text-sm font-bold text-gray-600 dark:text-white"> Text</p>
    ),
    cell: (info) => (
      <p className="text-sm font-bold text-navy-700 dark:text-white">
        {info.getValue()}
      </p>
    ),
  }),
  columnHelper.accessor("href", {
    id: "href",
    header: () => (
      <p className="text-sm font-bold text-gray-600 dark:text-white">Redirect to</p>
    ),
    cell: (info) => (
      <p className="text-sm font-bold text-navy-700 dark:text-white">
        {info.getValue()}
      </p>
    ),
  }),

 ];